// prettier-ignore-start
import ActionComment from "./ActionComment";


const ActionMessageFormCommentChatPrivate = () => {

    const fieldName = 'chat_comment';

    const data     = (app  ) => ActionComment().data    (app  , fieldName);
    const formCols = (props) => ActionComment().formCols(props, fieldName, 'приватный комментарий в чат');

    return {
        data     : data,
        formCols : formCols,
    }

};

export default ActionMessageFormCommentChatPrivate;
